<script setup>
import { CheckIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();
</script>
<template>
    <div class="flex items-center gap-2 p-2 my-3 whitespace-normal bg-gray-100 rounded-lg dark:bg-gray-900">
        <CheckIcon class="size-4 text-green-500" />
        <span class="text-xs text-gray-900 dark:text-white">{{ __("Configuration mise à jour") }}</span>
    </div>
</template>
